module.exports = __webpack_public_path__ + "img/n-dou.16656cc4.svg";